var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWebUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.102 17.048a7.12 7.12 0 0 0-14.205 0h-1.035v6.104h6.103l.069-.003a.763.763 0 0 0 .655-.52l.335-1.003h1.443l.335 1.004.026.069c.125.28.402.453.698.452h6.612v-6.103h-1.035zm-5.361 3.574-.027-.069a.764.764 0 0 0-.655-.452h-2.627a.763.763 0 0 0-.682.52l-.335 1.005h-3.01v-3.052h11.19v3.052h-3.52l-.334-1.004z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.754 28.521c.176 1.057 1.809 9.042 1.809 9.042H10.437s1.633-7.985 1.809-9.042l7.691-1.799s.157-.003.212.053c1.507 1.51 3.38 2.689 3.847 2.973l.004-.002.004.002c.468-.284 2.34-1.463 3.846-2.973.056-.056.213-.053.213-.053l7.691 1.799z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWebUsers);
export default __webpack_public_path__ + "static/media/ic-web-users.a75336e80423ada37901fe2bcf503d27.svg";
export { ForwardRef as ReactComponent };